var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trace"},[_vm._l((_vm.thread.stackTrace),function(trace,index){return _c('span',{key:index},[_vm._v(_vm._s(trace)),_c('br')])}),(!_vm.thread.stackTrace.length)?_c('span',[_vm._v("No Data")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }